import { render } from "./roles.vue?vue&type=template&id=47038436&scoped=true"
import script from "./roles.vue?vue&type=script&lang=js"
export * from "./roles.vue?vue&type=script&lang=js"

import "./roles.vue?vue&type=style&index=0&id=47038436&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47038436"]])

export default __exports__